module.exports = function getResource(label, vars = []) {
    const resources = {
        myReservations: 'Mes réservations',
        upcomingReservations: 'Réservations à venir',
        noReservationsLabel: 'Vous n’avez pas encore de réservation.',
        noReservationsButtonLabel: 'Voir ce qui se passe',
        noReservationsText: 'Consulter Ça se passe chez Sephora pour voir les disponibilités près de chez vous. Membres Beauty Insider, profitez de toutes les expériences offertes par Sephora, réservez votre premier service aujourd’hui!'
    };

    return resources[label];
};
